<script lang="ts">
    import Button from "@components_v2/Button/Button.svelte";
    import ChatIcon from "@components_v2/Icons/ChatIcon.svelte";
    import { createEventDispatcher } from "svelte";

    import T from "@components/T.svelte";

    export let questionsCount: number;

    const dispatch = createEventDispatcher();
</script>

<Button
    mode="link"
    size="small"
    ariaLabel="Ask a question"
    on:click={() => dispatch("goToQuestions")}
>
    <ChatIcon slot="icon-left" />
    {#if questionsCount === 1}
        1 <T
            namespace="reviews.ReviewsStarRatingWidget"
            translationKey="question"
        />
    {:else if questionsCount}
        <T
            namespace="reviews.ReviewsStarRatingWidget"
            translationKey="questions"
            translationOptions={{
                count: questionsCount,
            }}
        />
    {:else}
        <T
            namespace="reviews.critical.ReviewsStarRatingWidget"
            translationKey="ask_a_question"
        />
    {/if}
</Button>
